import "./App.css";
import Main from "./layout/Main";

function App() {
  return (
    <div className="App">
      <Main />
    </div>
  );
}

export default App;
